export class StorySession{
    storySessionId?: number;
    forStorybookId: number;
    byStudentId: number;
    forTeacherId?: number;
    expPointsEarned: number;
    sessionStatus: string;
    stoppedOnPageNumber?: number;
    createdDate: number;
    storybookName?: string;
    storybookReadingLevel?: string;
}